module.exports = __webpack_public_path__ + "static/media/bowling.fb52d90f.svg";